<div class="grid-item">
  <div class="grid grid-column">
    <div class="grid-item">
      <div class="typography typography-paragraph typography-h4">
        Влияние лекарственных препаратов
      </div>
      <div class="grid grid-gutter-24 grid-column">
        <div
          *ngFor="let drugGroup of drugInfluenceGroups"
          class="grid-item"
        >
          <div class="grid">
            <div class="grid-item">
              <div
                class="typography typography-paragraph typography-bold typography-headline"
              >
                {{ drugGroup.groupName }}
              </div>

              <app-bullet-list [items]="getDrugsListFromGroup(drugGroup)">
              </app-bullet-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
